import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { getStatus, getTaggingPromise, subscribe, type TaggingStatus } from "src/services";

import type { TaggingResult } from "src/services";

const TaggingContext = createContext<TaggingStatus>(getStatus());

export const TaggingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [status, setStatus] = useState<TaggingStatus>(getStatus);

  useEffect(() => {
    // Sync to any updates that arrived before this component mounted
    setStatus(getStatus());
    return subscribe(setStatus);
  }, []);

  return <TaggingContext.Provider value={status}>{children}</TaggingContext.Provider>;
};

export function useTaggingStatus(): TaggingStatus {
  return useContext(TaggingContext);
}
